// Fader slideshow

// Whenever a slide completes its fader transition, the animationend event handler rotates it to the bottom of the stack
// @see https://www.the-art-of-web.com/css/fading-slideshow-upgraded/

export function initSlideshow() {
    const slideShow = document.querySelectorAll('.fading-slideshow');

    // Abort if no slideshow on page
    if (!slideShow.length) return;

    document.querySelectorAll('.fading-slideshow > li').forEach((current) => {
        current.addEventListener('animationend', (e) => {
            e.target.parentNode.appendChild(e.target);
        });
    });
}
